var CsDynamicTableMixins = {
	methods: {
		/**
		 * 将表格请求数据之后处理的逻辑剥离出来，然后根据父组件传来的successBack属性来决定是否执行对应的成功回调方法
		 * @param {Object} response
		 */
		afterGetData(response) {
			let tableData = eval("response." + this.prop.dataProp);
			if(this.prop.disabledContion) {
				tableData.forEach((item, index, list) => {
					if(this.prop.disabledContion[2]) {
						list[index]._disabled = this.prop.disabledContion[0] == list[index][this.prop.disabledContion[1]]
					} else {
						// list[index]._disabled =this.prop.disabledContion[0]!= list[index][this.prop.disabledContion[1]]
					}

				})
			}
			this.tableData = tableData
			this.constructPageInfo(response)
			if(this.prop.successBack) {
				this.prop.successBack.apply(this, [].concat(response));
			}
		},

		getData() {
			if(this.prop.dataFun) {
				this.prop.dataFun.apply(this, [].concat(this.prop.dataFunArgs))
				return
			}
			if(this.prop.postMethod) {
				
				this.getApiData('post', this.prop.dataSrc + this.constructPageRequest(false) , this.prop.postData, response => {
					let datas = _cloneDeep(response);
					let data = {
						data : datas.rows,
						total :　datas.rows.size,
						pageSize : 10
					}
					
					this.afterGetData(data)
				});
			} else {
				if(this.prop.apiResource) {
					apiResource.get(this.constructPageRequest(false)).then((response)=> {
						this.afterGetData(response)
					})
				}  else {
					
					this.getApiData('get', this.prop.dataSrc + this.constructPageRequest(false) , {
						params: {}
					}, response => {
						this.afterGetData(response)
						
					});
				}
			}
		},

		/**
		 * 组装分页信息
		 * @param response
		 */
		constructPageInfo(response) {
			if(this.prop.pageableProp) {
				Object.keys(this.prop.pageableProp).forEach((key)=>{
					/**
					 * 由于在搜索不到数据时，如果后台接口返回一个非分页结构数据导致分页组装信息出错，
					 * 导致执行页码变更或者size变更事件,所以在下面加上判断规避该问题
					 */
					let value = eval("response." + this.prop.pageableProp[key]);
					if(typeof(value) == 'undefined') {
						this.pagination = {
							pageSize: 10,
							total: 0,
							pageSizes: [10, 20, 50, 100],
							currentPage: 1,
							order: "",
							showTotal: true,
							showSizer: true
						}
					} else {
						
						if(key == "currentPage") {
							/**
							 * iView分页组件存在问题描述如下
							 * 比如有11条数据，每页10条会分成两页，然后在第二页删除掉第第11条数据，那么页面会切到第一页，但是不会显示任何数据
							 * 这里加上if判断，如果表格数据为空，然后查询到的数据总数又是大于0，那么默认当前页减少一页，触发watch里面的currentPage变更，重新加载数据
							 */
							if(this.tableData.length == 0 && this.pagination.total > 0) {
								this.pagination[key] = value
							} else {
								this.pagination[key] = value + 1
							}
						} else {
							this.pagination[key] = value
						}
					}
				})
			}
		},
		handleCurrentRowChange(row){
			this.currentRow = row
		},
		/**
		 * 组装分布请求
		 * @param query
		 * @returns {*}
		 */
		constructPageRequest(query) {
			if(query) {
				/**
				 * postParams:用来表示获取数据url有参数传递
				 */
				if(this.prop && this.prop.postParams) {
					return "&size=" + this.pagination.pageSize + "&page=" + (this.pagination.currentPage - 1) + "&sort=" + this.pagination.order
				}
				return "?size=" + this.pagination.pageSize + "&page=" + (this.pagination.currentPage - 1) + "&sort=" + this.pagination.order
			} else {
				return {
					size: this.pagination.pageSize,
					page: this.pagination.currentPage - 1,
					order: this.pagination.order
				}
			}
		},

		/**
		 * 分页大小变更时事件
		 * @param pageSize
		 */
		handleSizeChange(pageSize) {
			this.$emit("pageSize",pageSize);
			this.$emit("partpageSize",pageSize);
			let tempPage = _.cloneDeep(this.pagination.currentPage);
			this.pagination.pageSize = pageSize;
			if(tempPage != 1) {
				this.pagination.currentPage = 1
			} else {
				this.getData();
			}
		},
		/**
		 * 页数变更时事件
		 * @param pageSize
		 */
		handleCurrentPageChange(currPage) {
			this.$emit("currentPage",currPage);
			this.$emit("partcurrentPage",currPage);
			this.pagination.currentPage = currPage;
		},
		handleSortChange(col) {
			if(col.column) {
				this.pagination.order = col.key + "," + (col.order == "asc" ? "ASC" : "DESC")
			}
			if(col.order){
				this.getData()
			}
		},
		/**
		 * 刷新数据
		 */
		refreshData() {
			this.getData()
		},
		/**
		 * 获取表头上的操作按钮
		 * @returns {*}
		 */
		getActions(){
			if(this.prop.showActions == false) {
				return null;
			}
			Object.assign(this.actions, {
				width: 5,
				def: [{
					name: '增加',
					handler:()=> {
						this.formInfo.title = "增加";
						this.formInfo.action = "save"
						this.formInfo.model = Object.assign({}, this.prop.emptyModel)
						this.dialogVisible = true;
					},
					type: 'primary',
					icon: 'md-add'
				}, {
					name: '删除',
					handler:()=> {
						if(this.prop.batchDeleFun) {
							this.prop.batchDeleFun.apply(this, [this.multipleSelection])
						} else if(this.prop.batchDelUri) {
							this.batchDeleteRequest();
						} else {
							this.$Message.info('请先配置批量删除路径或批量删除方法');
						}
					},
					type: 'error',
					icon: 'md-trash'
				}]
			})
			if(this.prop.actions) {
				this.prop.actions.def.forEach((item)=> {
					item.handler = ()=> {
						item.action.apply(this, [])
					}
				})
				if(this.prop.actions.replace) {
					Object.assign(this.actions, this.prop.actions)
				} else {
					this.actions.def = this.actions.def.concat(this.prop.actions.def)
				}
			}
			return this.actions
		},


		handleSelect(selection, row){
			this.multipleSelection = selection;
		},
		handleRowClick(row, index)  {
			this.$emit('rowClick', row)
			//如果点击的是selection则return,否则会出触发2次handleSelect
			if(row.type == 'selection') {
				var index = this.tableData.indexOf(row)
				return false;
			}
			//默认点击不选中，如果传参数rowClickSelect为true时单击row切换选中状态
			if(this.prop.rowClickSelect) {
				this.$refs.elTable.toggleRowSelection(row);
			}
			if(this.prop.rowClick) {
				this.prop.rowClick.apply(this, [row])
			}
		},
		/**
		 * 删除一条记录
		 * @param id
		 */
		handleDelete(id){
			this.$Modal.confirm({
				title: '提示',
				content: '此操作将永久删除, 是否继续?',
				okText: '确定',
				cancelText: '取消',
				onOk: () =>{
					if(this.prop.delFun) {
						this.prop.delFun.apply(this, [id])
					} else {
						if(this.prop.apiResource) {
							this.prop.apiResource.delete({
								id: id
							}).then(() => {
								this.$Message.success('删除成功');
								this.getData();
								this.multipleSelection=[]
							})
						} else {
							this.getApiData('delete', this.prop.delSrc + id, {}, (response) => {
								this.$Message.success('删除成功');
								this.getData();
								this.multipleSelection=[]
							})
						}
					}
				},
				onCancel: ()=>{
					this.$Message.info('已取消删除');
				}
			})
		},
		batchDeleteRequest(uri=this.prop.batchDelUri) {
			if(this.multipleSelection.length > 0) {
				this.$Modal.confirm({
					title: '提示',
					content: '此操作将永久删除, 是否继续?',
					okText: '确定',
					cancelText: '取消',
					onOk:()=> {
						var ids = this.multipleSelection.map((item)=> {
							return item.id;
						})
						this.getApiData('post', uri, ids, (response) => {
							this.$Message.success('删除成功');
							this.getData();
							this.multipleSelection=[]
						})
					},
					onCancel: ()=> {
						this.$Message.info('已取消删除');
					}
				})
			} else {
				this.$Message.warning('请先选择需要删除的选项');
			}
		},

	},
	computed: {
		paginationDef() {
			if(this.prop.pageInfo) {
				Object.assign(this.pagination, this.prop.pageInfo)
			}
			return this.pagination
		},
		currentPage() {
			return this.pagination.currentPage
		},
		spinShow() {
			return this.$store.state.spinShow
		},
		selectedLength(){
			return this.multipleSelection.length;
		}
	},
	created() {
		/**
		 * 新增默认排序功能，根据列定义的sortType进行排序
		 */
		let column=this.prop.columns.filter((item)=>{
			return item.sortType
		})
		if(column.length>0){
			let col=column[column.length-1];
			this.pagination.order = col.key + "," + col.sortType.toUpperCase();
		}
		this.getData()
		clearInterval(this.timer)
		/**
		 * 新增定时器刷新页面
		 */
		if(this.prop.timeout){
			this.timer=setInterval(()=>{
				if(this.multipleSelection.length == 0) {
					this.getData();
				}
			},this.prop.timeout)
		}
		this.getActions()
	},
	watch: {
		currentPage(val) {
			/**
			 * 防止页码切换过快，导致异步数据因返回速度差异导致渲染出错
			 */
			clearTimeout(this.pageTimeout)
			this.pageTimeout=setTimeout(()=>{
				this.getData();
			},150);
		}
	}
}

export default CsDynamicTableMixins



// WEBPACK FOOTER //
// ./src/components/dynamicTable/CsDynamicTableMixins.js